import gql from 'graphql-tag';
import { useQuery, useResult, useMutation } from '@vue/apollo-composable';
import { useProfileInfo } from '@models/profile/useCurrentProfile';

const { profileInfo } = useProfileInfo();

// graphql - 热图设置
const SET_HEATMAP_MUTATION = gql`
    mutation setHeatMapWithToken($input: SetHeatMapInput!) {
        setHeatMapWithToken(input: $input)
    }
`;

// export const areaConfig: any = {
//     'localhost:3002': 'l',
//     'dev.ptmind.com': '0',
//     'dev.ptmind.cn': '1',
//     'staging.ptmind.com': '2',
//     'staging.ptmind.cn': '3',
//     'www.ptengine.jp': '4',
//     'www.ptengine.com': '5'
// };

export function addProtocol(url: string): string {
    const reg = /^(http|https:\/\/)/;
    return url !== '' && !reg.test(url) ? `http://${url}` : url;
}

/**
 * 热图设置
 */
export function setHeatMap(option: any, token: string) {
    const { mutate: setHeatMapWithToken } = useMutation(SET_HEATMAP_MUTATION);
    option.dataParameter.timeZone = profileInfo.value?.timeZone;
    const SetHeatMapInput = {
        token,
        config: option
    };
    return setHeatMapWithToken({ input: SetHeatMapInput })
        .then((result: any) => {
            return result.data.setHeatMapWithToken;
        })
        .catch((err: any) => {
            console.log('setHeatMapWithToken error----->', err);
            return false;
        });
}
